<!-- <div class="col-lg-12 selected-pages p-2 float-left breadcrumb">
<ul *ngIf="!hideBreadcrumbs" class="p-0 m-0">
  <li *ngFor="let crumb of crumbs$ | async">
    <a [routerLink]="crumb.link" [innerHTML]="getLabel(crumb.label)"></a>
  </li>
</ul>

<ul *ngIf="hideBreadcrumbs">
  <li *ngFor="let crumb of breadCrumbs">
    <a [href]="openLink(crumb[1])">{{ crumb[0] }}</a>
  </li>
</ul>
</div> -->
@if (!searchpage) {
  <div>
    <div class="breadcrumb">
      <div class="breadcrumb-container">
        <nav class="breadcrumb-nav">
          @if (!hideBreadcrumbs) {
            @for (crumb of crumbs$ | async; track crumb; let last = $last) {
              @if (!last) {
                <a [routerLink]="crumb.link" [innerHTML]="getLabel(crumb.label)"></a>
              }
              @if (last) {
                <span [innerHTML]="getLabel(crumb.label)"></span>
              }
              @if (!last) {
                <span class="breadcrumb-separator">&gt;</span>
              }
            }
          }
          @if (hideBreadcrumbs) {
            @for (crumb of breadCrumbs; track crumb; let last = $last) {
              @if (!last) {
                <a [href]="openLink(crumb[1])">{{ crumb[0] }}</a>
              }
              @if (last) {
                <span>{{ crumb[0] }}</span>
              }
              @if (!last) {
                <span class="breadcrumb-separator">&gt;</span>
              }
            }
          }
        </nav>
      </div>
    </div>
  </div>
}
